var map = {
	"./Algeria.svg": 83389,
	"./Ashburn, VA.svg": 96288,
	"./Berlin, DE.svg": 50101,
	"./Dallas, TX.svg": 52693,
	"./East Timor.svg": 37934,
	"./London, UK.svg": 75850,
	"./Los Angeles, CA.svg": 2197,
	"./MacPherson, SG.svg": 21306,
	"./Miami, FL.svg": 38287,
	"./Rapa Nui.svg": 49402,
	"./abkhazia.svg": 33707,
	"./afghanistan.svg": 37126,
	"./aland islands.svg": 79336,
	"./albania.svg": 19344,
	"./americansamoa.svg": 55563,
	"./andorra.svg": 53531,
	"./angola.svg": 61166,
	"./anguilla.svg": 36855,
	"./antiguaandbarbuda.svg": 82021,
	"./argentina.svg": 41535,
	"./armenia.svg": 49309,
	"./aruba.svg": 87181,
	"./australia.svg": 13974,
	"./austria.svg": 57505,
	"./azerbaijan.svg": 62811,
	"./azores islands.svg": 66108,
	"./bahamas.svg": 54123,
	"./bahrain.svg": 39883,
	"./balearic islands.svg": 14213,
	"./bangladesh.svg": 45195,
	"./barbados.svg": 90154,
	"./basque country.svg": 7491,
	"./belarus.svg": 81112,
	"./belgium.svg": 98483,
	"./belize.svg": 48825,
	"./benin.svg": 7606,
	"./bermuda.svg": 77456,
	"./bhutan.svg": 16804,
	"./bolivia.svg": 79392,
	"./bonaire.svg": 23512,
	"./bosniaandherzegovina.svg": 59853,
	"./botswana.svg": 77897,
	"./brazil.svg": 44034,
	"./british columbia.svg": 1239,
	"./british indian ocean territory.svg": 93826,
	"./british virgin islands.svg": 36662,
	"./brunei.svg": 34787,
	"./bulgaria.svg": 91283,
	"./burkina faso.svg": 68445,
	"./burundi.svg": 71867,
	"./cambodia.svg": 33442,
	"./cameroon.svg": 66032,
	"./canada.svg": 52026,
	"./canary islands.svg": 88234,
	"./cape verde.svg": 63987,
	"./cayman islands.svg": 75921,
	"./central african republic.svg": 7633,
	"./ceuta.svg": 71208,
	"./chad.svg": 50038,
	"./chile.svg": 97783,
	"./china.svg": 95181,
	"./christmas island.svg": 26663,
	"./cocos island.svg": 56142,
	"./colombia.svg": 54594,
	"./comoros.svg": 17166,
	"./cook islands.svg": 15190,
	"./corsica.svg": 59428,
	"./costa rica.svg": 78795,
	"./croatia.svg": 27719,
	"./cuba.svg": 49159,
	"./curacao.svg": 88934,
	"./cyprus.svg": 59694,
	"./czech republic.svg": 8231,
	"./democratic republic of congo.svg": 78796,
	"./denmark.svg": 7370,
	"./djibouti.svg": 7782,
	"./dominica.svg": 49162,
	"./dominican republic.svg": 41284,
	"./ecuador.svg": 36077,
	"./egypt.svg": 98145,
	"./el salvador.svg": 42887,
	"./england.svg": 79703,
	"./equatorial guinea.svg": 4954,
	"./eritrea.svg": 78714,
	"./estonia.svg": 76645,
	"./ethiopia.svg": 97949,
	"./europeanunion.svg": 47584,
	"./falkland islands.svg": 89901,
	"./faroe islands.svg": 94657,
	"./fiji.svg": 34908,
	"./finland.svg": 53072,
	"./france.svg": 50077,
	"./french polynesia.svg": 10490,
	"./gabon.svg": 7917,
	"./galapagos islands.svg": 8923,
	"./gambia.svg": 68739,
	"./georgia.svg": 18992,
	"./ghana.svg": 76033,
	"./gibraltar.svg": 7632,
	"./greece.svg": 18493,
	"./greenland.svg": 44598,
	"./grenada.svg": 56026,
	"./guam.svg": 99610,
	"./guatemala.svg": 28719,
	"./guernsey.svg": 76698,
	"./guinea bissau.svg": 826,
	"./guinea.svg": 50515,
	"./guyana.svg": 62901,
	"./haiti.svg": 91299,
	"./hawaii.svg": 33647,
	"./honduras.svg": 61248,
	"./hong kong.svg": 63169,
	"./hungary.svg": 86850,
	"./iceland.svg": 54762,
	"./india.svg": 20573,
	"./indonesia.svg": 47102,
	"./iran.svg": 17556,
	"./iraq.svg": 56019,
	"./ireland.svg": 65589,
	"./isle of man.svg": 34620,
	"./israel.svg": 18424,
	"./italy.svg": 6453,
	"./ivory coast.svg": 38953,
	"./jamaica.svg": 21530,
	"./japan.svg": 3056,
	"./jersey.svg": 7364,
	"./jordan.svg": 30854,
	"./kazakhstan.svg": 39338,
	"./kenya.svg": 24488,
	"./kiribati.svg": 13333,
	"./kosovo.svg": 86093,
	"./kuwait.svg": 36059,
	"./kyrgyzstan.svg": 60892,
	"./laos.svg": 90351,
	"./latvia.svg": 75617,
	"./lebanon.svg": 55367,
	"./lesotho.svg": 48186,
	"./liberia.svg": 71650,
	"./libya.svg": 33503,
	"./liechtenstein.svg": 44107,
	"./lithuania.svg": 64945,
	"./luxembourg.svg": 59840,
	"./macao.svg": 33149,
	"./macedonia.svg": 21563,
	"./madagascar.svg": 19180,
	"./madeira.svg": 75999,
	"./malawi.svg": 72063,
	"./malaysia.svg": 73973,
	"./maldives.svg": 64527,
	"./mali.svg": 7215,
	"./malta.svg": 54439,
	"./marshall island.svg": 30441,
	"./martinique.svg": 17033,
	"./mauritania.svg": 23207,
	"./mauritius.svg": 31325,
	"./melilla.svg": 62936,
	"./mexico.svg": 82501,
	"./micronesia.svg": 60424,
	"./moldova.svg": 9916,
	"./monaco.svg": 79149,
	"./mongolia.svg": 24234,
	"./montenegro.svg": 43333,
	"./montserrat.svg": 48925,
	"./morocco.svg": 93122,
	"./mozambique.svg": 51626,
	"./myanmar.svg": 24237,
	"./namibia.svg": 68135,
	"./nato.svg": 70324,
	"./nauru.svg": 32819,
	"./nepal.svg": 58306,
	"./netherlands.svg": 96468,
	"./new zealand.svg": 7101,
	"./nicaragua.svg": 36089,
	"./niger.svg": 66723,
	"./nigeria.svg": 95633,
	"./niue.svg": 37989,
	"./norfolk island.svg": 602,
	"./north korea.svg": 34727,
	"./northern cyprus.svg": 54324,
	"./northern marianas islands.svg": 340,
	"./norway.svg": 81054,
	"./oman.svg": 68505,
	"./orkney islands.svg": 57056,
	"./ossetia.svg": 84804,
	"./pakistan.svg": 57525,
	"./palau.svg": 72997,
	"./palestine.svg": 89677,
	"./panama.svg": 78544,
	"./papua new guinea.svg": 47314,
	"./paraguay.svg": 64572,
	"./peru.svg": 94785,
	"./philippines.svg": 39757,
	"./pitcairn islands.svg": 80922,
	"./poland.svg": 10608,
	"./portugal.svg": 10730,
	"./puerto rico.svg": 68448,
	"./qatar.svg": 5579,
	"./republic of the congo.svg": 48068,
	"./romania.svg": 46137,
	"./russia.svg": 96063,
	"./rwanda.svg": 88705,
	"./saba island.svg": 93262,
	"./sahrawi arab democratic republic.svg": 10454,
	"./saint kitts and nevis.svg": 43860,
	"./samoa.svg": 62101,
	"./san marino.svg": 11450,
	"./sao tome and prince.svg": 61042,
	"./sardinia.svg": 88293,
	"./saudi arabia.svg": 38242,
	"./scotland.svg": 11264,
	"./senegal.svg": 84953,
	"./serbia.svg": 60382,
	"./seychelles.svg": 36317,
	"./sierra leone.svg": 82349,
	"./sint eustatius.svg": 80023,
	"./sint maarten.svg": 58186,
	"./slovakia.svg": 78648,
	"./slovenia.svg": 20653,
	"./solomon islands.svg": 93307,
	"./somalia.svg": 68638,
	"./somaliland.svg": 54758,
	"./south africa.svg": 1735,
	"./south korea.svg": 909,
	"./south sudan.svg": 58106,
	"./spain.svg": 44167,
	"./sri lanka.svg": 58965,
	"./st barts.svg": 12453,
	"./st lucia.svg": 67907,
	"./st vincent and the grenadines.svg": 1934,
	"./sudan.svg": 625,
	"./suriname.svg": 23634,
	"./swaziland.svg": 10683,
	"./sweden.svg": 77504,
	"./switzerland.svg": 69351,
	"./syria.svg": 5080,
	"./taiwan.svg": 37672,
	"./tajikistan.svg": 65346,
	"./tanzania.svg": 74390,
	"./thailand.svg": 66637,
	"./tibet.svg": 38878,
	"./togo.svg": 12825,
	"./tokelau.svg": 30963,
	"./tonga.svg": 36323,
	"./transnistria.svg": 24976,
	"./trinidad and tobago.svg": 48294,
	"./tunisia.svg": 66387,
	"./turkey.svg": 37730,
	"./turkmenistan.svg": 77181,
	"./turks and caicos.svg": 76934,
	"./tuvalu.svg": 43611,
	"./uganda.svg": 16012,
	"./ukraine.svg": 26763,
	"./united arab emirates.svg": 72537,
	"./unitednations.svg": 41351,
	"./unitedstates.svg": 18255,
	"./uruguay.svg": 71636,
	"./uzbekistan.svg": 14278,
	"./vanuatu.svg": 60396,
	"./vatican city.svg": 33417,
	"./venezuela.svg": 48841,
	"./vietnam.svg": 68376,
	"./virgin islands.svg": 77793,
	"./wales.svg": 27056,
	"./yemen.svg": 31914,
	"./zambia.svg": 60904,
	"./zimbabwe.svg": 1007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68492;